import { Injectable } from '@angular/core';
import { Config } from './config/config'
import { HttpClient } from '@angular/common/http'
import { StorageService } from './config/storage.service'

@Injectable({
  providedIn: 'root'
})
export class RecaptchaService extends Config{

  constructor(
      private http:HttpClient,
      private storage:StorageService,
  ) { 
     super()
  }

  recaptcha(item:any){
    let url = 'dashboard/recap'
    return this.http.post(this.BASE_URL_API + url,item,this.storage.getHeaders())
  }

}
